export class EngineVersionUtils {
    public static extractVersionFromFileName(engineFileName: string, fileNamePrefix: string): string {
        const regex = new RegExp(
            `${fileNamePrefix}(\\d+)_(\\d+)_(\\d+)(?:_([\\w\\d_]+?)_([^_\\.]+))?(?:\\.(?:[\\d\\w-]+))?(?:\\.test)?(?:\\.min)?(?:(?:\\.js)|(?:\\.css))(?:\\.map)?$`
        );
        const match = regex.exec(engineFileName);
        if (match == undefined) {
            throw new Error(`Cannot extract engine version from '${engineFileName}'`);
        }
        const major = match[1];
        const minor = match[2];
        const patch = match[3];
        const preId = match[4];
        const prereleaseNumber = match[5];
        let result = `${major}.${minor}.${patch}`;
        if (preId != undefined) {
            result += `-${preId.replace(/_/g, "-")}.${prereleaseNumber}`;
        }
        return result;
    }

    public static extractVersionFromEngineFileName(engineFileName: string): string {
        return EngineVersionUtils.extractVersionFromFileName(engineFileName, "candy_v");
    }

    public static extractVersionFromEngineLoaderFileName(engineFileName: string): string {
        return EngineVersionUtils.extractVersionFromFileName(engineFileName, "engineLoader_v");
    }

    public static engineVersionToName(engineVersion: string): string {
        return `v${engineVersion.replace(/[\.\-]/gi, "_")}`;
    }
}
